import { Component } from '@angular/core';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-probe-graph',
  templateUrl: './probe-graph.component.html',
  styleUrls: ['./probe-graph.component.css']
})
export class ProbeGraphComponent {

  data: any;
  probeMismatch: any;
  showSpinner: boolean = true;
  constructor(private dataService: DataService) {
  }

  ngOnInit() {
    this.dataService.getProbeMismatches().then(data => {
      this.probeMismatch = data;
      this.buildLineChart();
      this.showSpinner = false;
    });
  }

  buildLineChart(){
    this.data = {
      labels: this.probeMismatch.months,
      datasets: this.probeMismatch.probeMismatches.map((s: { probeName: any; amounts: any; }) => ({label: s.probeName, data: s.amounts}))
    }
  }
}
